import { render } from "./CourseInviteContent.vue?vue&type=template&id=1245806a&scoped=true"
import script from "./CourseInviteContent.vue?vue&type=script&lang=js"
export * from "./CourseInviteContent.vue?vue&type=script&lang=js"

import "./CourseInviteContent.vue?vue&type=style&index=0&id=1245806a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1245806a"]])

export default __exports__